import { BaseEjariContract, EjariContractStatus, EjariProperty } from "./Entity";
import { getContractStatus, getLastContract } from "./Utils";
import { EjariUserType } from "@eres/ejari-core/reducers/EjariData";

export function canDoContractOperations( contract: BaseEjariContract ) {
	if ( contract && contract.ContractTypeId && contract.ContractTypeId === 2 ) {
		return contract.ContractStatusId === EjariContractStatus.UNDER_AUDIT || contract.ContractStatusId === EjariContractStatus.PASS_AUDIT;
	} else {
		let status = getContractStatus( contract );
		if ( status != undefined ) {
			return status === EjariContractStatus.ACTIVE || status === EjariContractStatus.PASS_AUDIT;
		}
	}
	return false;
}

export function canEditProperty( property: EjariProperty, userType: EjariUserType ): boolean {
	if ( userType === "mc" ) return true;
	else if ( userType === "owner" ) {
		return property.AssociatedManagementContract == null;
	}
	return false;
}

export function canDownload( property: EjariProperty, userType: EjariUserType ): boolean {
	const c = getLastContract( property );
	if ( c ) {
		if ( userType === "mc" ) return true;
		else if ( userType === "owner" ) {
			if ( property.AssociatedManagementContract == null ) {
				return true;
			} else if ( property.AssociatedManagementContract.McTypeId === 1 ) {
				return true;
			}
		}
	}
	return false;
}

export function canCreateNewContract( property: EjariProperty, userType: EjariUserType ): boolean {
	return !property.IsRented;
}

export function canRenewContract( property: EjariProperty, userType: EjariUserType ): boolean {
	const c = getLastContract( property );
	return !!( c && canDoContractOperations( c ) );

}

export function canTerminateContract( property: EjariProperty, userType: EjariUserType ): boolean {
	const c = getLastContract( property );
	return !!( c && canDoContractOperations( c ) );
}

export function getEjariContractStatusClass( statusId?: number ) {
	switch ( statusId ) {
		case EjariContractStatus.PENDING:
			return "pending";

		case EjariContractStatus.ACTIVE:
		case EjariContractStatus.PASS_AUDIT:
		case EjariContractStatus.UNDER_AUDIT:
		case EjariContractStatus.COMPLETED:
			return "completed";

		case EjariContractStatus.TERMINATED:
			return "rejected";

		case EjariContractStatus.CANCELED:
			return "cancelled";
	}
}

export function canHandTakeOver( property: EjariProperty, userType: EjariUserType ): boolean {
	if ( userType === "owner" ) {
		const c = getLastContract( property );
		return property.AssociatedManagementContract == null && c !== undefined && canDoContractOperations( c );
	}
	return false;
}
